import shopifyGenericDefaults from '../shopify-generic/config.js';

const forceVehicleSelectionInterval = 60;
const vehicleSelectionDelayCookie = 'cm_force-vehicle-selection-later';
const isProductPage = window.Convermax.Shopify?.pageType === 'product';

const onVerifyFitmentInitResponseReceived = (response) => {
  const product = response.Items?.[0];
  const shouldOpenVehicleDialog =
    window.Convermax.helpers.isStorageAllowed(vehicleSelectionDelayCookie) &&
    isProductPage &&
    product &&
    !['universal', 'unknown', 'nonVehicleProducts'].includes(product.fitsTheVehicle) &&
    !window.Convermax.isVehicleSelected() &&
    !window.Convermax.helpers.getCookie(vehicleSelectionDelayCookie);

  if (shouldOpenVehicleDialog) {
    window.Convermax.helpers.setCookie(
      vehicleSelectionDelayCookie,
      'true',
      new Date(Date.now() + forceVehicleSelectionInterval * 60 * 1000),
    );
    window.Convermax.openVehicleDialog();
  }
};

export default {
  ...shopifyGenericDefaults,
  includes: ['shopify-generic'],
  fitmentSearch: {
    ...shopifyGenericDefaults.fitmentSearch,
    forceVehicleSelection: true,
    forceVehicleSelectionInterval,
    onVerifyFitmentInitResponseReceived,
  },
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (widget) =>
        widget.name !== 'HeaderVehicleWidget' &&
        widget.name !== 'HomeVehicleWidget_tab' &&
        widget.name !== 'SearchVehicleWidget' &&
        widget.name !== 'VehicleWidgetDialog',
    ),
    {
      ...shopifyGenericDefaults.Widgets.find((widget) => widget.name === 'HeaderVehicleWidget'),
      template: 'fitmentSearch/homeVehicleWidget',
    },
    {
      ...shopifyGenericDefaults.Widgets.find((widget) => widget.name === 'HomeVehicleWidget_tab'),
      template: 'fitmentSearch/homeVehicleWidget',
    },
    {
      ...shopifyGenericDefaults.Widgets.find((widget) => widget.name === 'SearchVehicleWidget'),
      columnBreakpoint: 650,
    },
    {
      ...shopifyGenericDefaults.Widgets.find((widget) => widget.name === 'VehicleWidgetDialog'),
      doNotRedirectOnVehicleSelect: isProductPage,
    },
  ],
};
